import React, { useState } from 'react';
import GasExcelSearchBar from './excelSearchBar/GasExcelSearchBar';
import GasExcelPreview from './excelPreview/GasExcelPreview';

const GasExcel = (props) => {
  const [searchMap, setSearchMap] = useState({
    moduleIdx: 0,
    beginDate: new Date(),
    endDate: new Date(),
  });
  return (
    <section>
      <GasExcelSearchBar searchMap={searchMap} setSearchMap={setSearchMap} />
      <GasExcelPreview searchMap={searchMap} flag={props.flag} />
    </section>
  );
};

export default GasExcel;
